import api from "../axios/api";
import { IEquipment } from "../models/iequipment";
import Axios from "axios";
let CancelToken = Axios.CancelToken;
let fetchEquipmentsPublicById_cancel: any;

export const fetchEquipmentsPublicByIdWithServicesReplicateService = (id: string): Promise<IEquipment> => {
  fetchEquipmentsPublicById_cancel && fetchEquipmentsPublicById_cancel()

  return api.get(`/equipmentsPublic/${id}/servicesReplicated`, {
    cancelToken: new CancelToken(function executor(c) {
      fetchEquipmentsPublicById_cancel = c;
    })
  })
}
